(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const safeStore = {
    get(key) { try { return JSON.parse(localStorage.getItem(key)); } catch (_) { return null; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} },
    remove(key) { try { localStorage.removeItem(key); } catch (_) {} }
  };
  const copyText = async (text, trigger) => {
    try {
      await navigator.clipboard.writeText(text);
      const original = trigger.textContent;
      trigger.textContent = 'Copied';
      setTimeout(() => { trigger.textContent = original; }, 1800);
    } catch (_) {
      const area = document.createElement('textarea');
      area.value = text; area.setAttribute('readonly', ''); area.style.position = 'fixed'; area.style.opacity = '0';
      document.body.appendChild(area); area.select(); document.execCommand('copy'); area.remove();
    }
  };
  const printPage = () => window.print();
  $$('[data-tool-print]').forEach(button => button.addEventListener('click', printPage));

  function initFormatFinder(root) {
    const form = $('[data-tool-form]', root);
    if (!form) return;
    const formats = {
      capsule: { label: 'Capsule Manufacturing', icon: '◒', description: 'A strong path for dry ingredients, precise serving architecture, portability, and taste isolation.', fallback: '/pages/capsule-manufacturing' },
      tablet: { label: 'Tablet Manufacturing', icon: '⬭', description: 'Well suited to compressed dry systems, precise dosing, familiar routines, and efficient unit formats.', fallback: '/pages/tablet-manufacturing' },
      gummy: { label: 'Gummy Manufacturing', icon: '⌁', description: 'A consumer-forward option when flavor, texture, chewability, and routine enjoyment matter.', fallback: '/pages/gummy-manufacturing' },
      powder: { label: 'Powder Manufacturing', icon: '△', description: 'A leading choice for high-gram servings, mixability, hydration, protein, collagen, and performance systems.', fallback: '/pages/powder-manufacturing' },
      liquid: { label: 'Liquid Manufacturing', icon: '◉', description: 'A flexible path for droppers, syrups, suspensions, shots, and ready-to-use liquid delivery systems.', fallback: '/pages/liquid-manufacturing' },
      softgel: { label: 'Softgel Manufacturing', icon: '◓', description: 'A premium option for oil-based, lipid-soluble, and taste-isolated formulations.', fallback: '/pages/softgel-manufacturing' },
      chocolate: { label: 'Chocolate Molded Bars', icon: '▦', description: 'A differentiated functional format where flavor, portioning, inclusions, and premium experience lead.', fallback: '/pages/chocolate-molded-bars' }
    };
    const questions = $$('[data-question]', form);
    const progress = $('[data-tool-progress]', root);
    const error = $('[data-tool-error]', form);
    const results = $('[data-tool-results]', root);
    const resultGrid = $('[data-format-results]', root);
    const updateProgress = () => {
      const answered = questions.filter(q => $('input:checked', q)).length;
      if (progress) progress.style.width = `${Math.round((answered / questions.length) * 100)}%`;
      if (error) error.hidden = true;
    };
    form.addEventListener('change', updateProgress);
    form.addEventListener('reset', () => {
      setTimeout(() => { if (progress) progress.style.width = '0%'; if (results) results.hidden = true; if (error) error.hidden = true; }, 0);
    });
    form.addEventListener('submit', event => {
      event.preventDefault();
      const selected = questions.map(q => $('input:checked', q));
      if (selected.some(v => !v)) { error.hidden = false; error.focus?.(); return; }
      const scores = Object.fromEntries(Object.keys(formats).map(key => [key, 0]));
      selected.forEach(input => {
        String(input.dataset.score || '').split(',').forEach(pair => {
          const [key, raw] = pair.split(':');
          if (key in scores) scores[key] += Number(raw || 0);
        });
      });
      const ranked = Object.entries(scores).sort((a, b) => b[1] - a[1]).slice(0, 3);
      const topScore = ranked[0][1] || 1;
      const labels = selected.map(input => input.parentElement.textContent.trim());
      resultGrid.innerHTML = ranked.map(([key, score], index) => {
        const item = formats[key];
        const url = root.dataset[`${key}Url`] || item.fallback;
        const match = Math.max(55, Math.round((score / topScore) * 100));
        const reason = index === 0 ? `Strongest alignment with your selected product experience and formula priorities.` : `A credible alternate path to compare during technical review.`;
        return `<article class="format-result-card${index === 0 ? ' is-primary' : ''}"><div class="format-result-card__rank">${index === 0 ? 'Leading Match' : `Alternative ${index}`}</div><div class="format-result-card__score"><span>${item.icon}</span><strong>${match}%</strong><small>relative fit</small></div><h3>${item.label}</h3><p>${item.description}</p><p class="format-result-card__reason">${reason}</p><a class="text-link" href="${url}">Explore ${item.label.replace(' Manufacturing','')} →</a></article>`;
      }).join('');
      results.hidden = false;
      results.dataset.answers = labels.join(' | ');
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    updateProgress();
  }

  function initPackagingChecklist(root) {
    const inputs = $$('input[type="checkbox"][data-item]', root);
    if (!inputs.length) return;
    const key = `biocorp-packaging-checklist:${location.pathname}`;
    const saved = safeStore.get(key) || [];
    inputs.forEach(input => { input.checked = saved.includes(input.dataset.item); });
    const percent = $('[data-checklist-percent]', root);
    const bar = $('[data-checklist-bar]', root);
    const message = $('[data-checklist-message]', root);
    const missingList = $('[data-checklist-missing]', root);
    const update = () => {
      const checked = inputs.filter(i => i.checked);
      const missing = inputs.filter(i => !i.checked);
      const pct = Math.round((checked.length / inputs.length) * 100);
      percent.textContent = `${pct}%`; bar.style.width = `${pct}%`;
      message.textContent = pct === 100 ? 'Your planning inputs are complete enough for a structured packaging review.' : pct >= 75 ? 'Most inputs are defined. Resolve the remaining items before final artwork or production setup.' : pct >= 40 ? 'The project has a foundation, but several dependencies still need owners.' : 'Start with the essentials that define your packaging system.';
      missingList.innerHTML = missing.length ? missing.map(i => `<li>${i.dataset.item}</li>`).join('') : '<li class="is-complete">No open checklist items.</li>';
      safeStore.set(key, checked.map(i => i.dataset.item));
    };
    inputs.forEach(input => input.addEventListener('change', update));
    $('[data-checklist-copy]', root)?.addEventListener('click', event => {
      const missing = inputs.filter(i => !i.checked).map(i => `• ${i.dataset.item}`);
      const text = `BIOCORP PACKAGING READINESS ACTION LIST\n\n${missing.length ? missing.join('\n') : 'All checklist items are marked complete.'}\n\nPlanning tool only; final requirements require technical and regulatory review.`;
      copyText(text, event.currentTarget);
    });
    $('[data-tool-reset]', root)?.addEventListener('click', () => {
      inputs.forEach(i => { i.checked = false; }); safeStore.remove(key); update();
    });
    update();
  }

  function initDocumentationPlanner(root) {
    const form = $('[data-doc-controls]', root);
    const output = $('[data-doc-output]', root);
    const actions = $('[data-doc-actions]', root);
    if (!form || !output) return;
    const base = [
      ['Product Definition', 'Product brief, target consumer, intended use, and commercial objectives'],
      ['Formula', 'Current formula, serving size, ingredient list, and formulation assumptions'],
      ['Formula', 'Ingredient specifications, supplier status, and sourcing responsibilities'],
      ['Packaging', 'Primary package format, size, closure, count, and compatibility questions'],
      ['Label', 'Draft label copy, Supplement Facts inputs, directions, warnings, and claims inventory'],
      ['Project Control', 'Decision owners, approval gates, target timeline, and open-risk register']
    ];
    const stage = {
      formula: [['Formula', 'Formula version control and change log'], ['Quality', 'Initial testing, specification, and stability strategy'], ['Commercial', 'Preliminary cost, run-size, and packaging assumptions']],
      production: [['Production', 'Master manufacturing instructions or production-ready formula package'], ['Quality', 'Raw material identity, specification, and certificate requirements'], ['Quality', 'In-process controls and finished-product testing plan'], ['Documentation', 'Batch record, release criteria, and document-retention responsibilities'], ['Packaging', 'Approved dielines, print-ready artwork, UPC, coding, and case-pack details']],
      retail: [['Retail Readiness', 'Retailer or distributor vendor documentation requirements'], ['Retail Readiness', 'Case pack, pallet pattern, shipping labels, and routing requirements'], ['Quality', 'Finished-product COA and release-document expectations'], ['Commercial', 'Forecast, replenishment assumptions, launch windows, and service-level needs'], ['Traceability', 'Lot traceability, retain, complaint, and recall-process responsibilities']]
    };
    const channel = {
      amazon: [['Marketplace', 'Marketplace listing inputs, image requirements, packaging durability, and FBA preparation needs']],
      retail: [['Retail', 'UPC/GTIN, case barcode, shelf dimensions, case pack, and retailer portal requirements']],
      multi: [['Channel Control', 'Channel-specific packaging, bundle, barcode, and fulfillment differences']]
    };
    const path = {
      custom: [['Development', 'Formula development scope, prototype rounds, sensory targets, and approval criteria']],
      prototype: [['Prototype', 'Base-formula selection, customization limits, sample approval, and scale-up decision gate']],
      copack: [['Co-Packing', 'Incoming bulk-product specifications, ownership, release status, and chain-of-custody requirements']]
    };
    let currentItems = [];
    const generate = () => {
      const data = new FormData(form);
      const stageValue = data.get('stage'); const channelValue = data.get('channel'); const pathValue = data.get('path');
      currentItems = [...base, ...(stage[stageValue] || []), ...(channel[channelValue] || []), ...(path[pathValue] || [])];
      const grouped = currentItems.reduce((acc, [cat, text]) => { (acc[cat] ||= []).push(text); return acc; }, {});
      output.innerHTML = `<div class="planner-output__header"><p class="v3-eyebrow">Generated Plan</p><h3>${currentItems.length} planning documents and decisions</h3><p>Mark items as they are located, drafted, assigned, or confirmed.</p></div>${Object.entries(grouped).map(([cat, items]) => `<section class="planner-category"><h4>${cat}</h4>${items.map((item, i) => `<label><input type="checkbox" data-doc-item><span>${item}</span></label>`).join('')}</section>`).join('')}`;
      actions.hidden = false;
      output.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    form.addEventListener('submit', event => { event.preventDefault(); generate(); });
    $('[data-doc-copy]', root)?.addEventListener('click', event => {
      const text = `BIOCORP PROJECT DOCUMENTATION PLAN\n\n${currentItems.map(([cat, item]) => `• [${cat}] ${item}`).join('\n')}\n\nEducational planning tool only. Final requirements depend on the product, market, channel, and applicable review.`;
      copyText(text, event.currentTarget);
    });
  }

  function initReadinessScorecard(root) {
    const form = $('[data-scorecard-form]', root);
    if (!form) return;
    const questions = $$('.score-question', form);
    const error = $('[data-tool-error]', form);
    const results = $('[data-readiness-results]', root);
    form.addEventListener('reset', () => setTimeout(() => { results.hidden = true; error.hidden = true; }, 0));
    form.addEventListener('submit', event => {
      event.preventDefault();
      const answers = questions.map(q => $('input:checked', q));
      if (answers.some(a => !a)) { error.hidden = false; error.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      error.hidden = true;
      const total = answers.reduce((sum, a) => sum + Number(a.value), 0);
      const score = Math.round((total / (questions.length * 2)) * 100);
      $('[data-readiness-score]', root).textContent = score;
      const label = score >= 85 ? 'Strong planning readiness' : score >= 65 ? 'Promising, with defined gaps' : score >= 40 ? 'Important dependencies remain' : 'Early-stage planning required';
      $('[data-readiness-label]', root).textContent = label;
      $('[data-readiness-summary]', root).textContent = score >= 85 ? 'The project appears well organized for a detailed technical and commercial review.' : score >= 65 ? 'The foundation is present, but a handful of unfinished decisions could still affect timing or cost.' : score >= 40 ? 'Several cross-functional inputs should be resolved before the project is treated as production-ready.' : 'Focus first on product definition, ownership, and the core decisions that unlock technical review.';
      const byCategory = {};
      questions.forEach((q, i) => { const cat = q.dataset.category; const value = Number(answers[i].value); (byCategory[cat] ||= []).push(value); });
      $('[data-readiness-breakdown]', root).innerHTML = Object.entries(byCategory).map(([cat, values]) => { const pct = Math.round(values.reduce((a,b)=>a+b,0)/(values.length*2)*100); return `<div class="readiness-pillar"><div><strong>${cat}</strong><span>${pct}%</span></div><div><i style="width:${pct}%"></i></div></div>`; }).join('');
      const gaps = questions.map((q, i) => ({ text: $('legend', q).textContent.replace(/^\d+/, '').trim(), value: Number(answers[i].value), category: q.dataset.category })).filter(x => x.value < 2).sort((a,b)=>a.value-b.value);
      $('[data-readiness-gaps]', root).innerHTML = gaps.length ? gaps.slice(0, 8).map(g => `<li><strong>${g.category}:</strong> ${g.text} <span>${g.value === 0 ? 'Not started' : 'In progress'}</span></li>`).join('') : '<li>No unfinished items were identified in this self-assessment.</li>';
      const ring = $('[data-readiness-ring]', root); ring.style.setProperty('--score', `${score * 3.6}deg`);
      results.hidden = false; results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  $$('[data-bc-tool="format-finder"]').forEach(initFormatFinder);
  $$('[data-bc-tool="packaging-checklist"]').forEach(initPackagingChecklist);
  $$('[data-bc-tool="documentation-planner"]').forEach(initDocumentationPlanner);
  $$('[data-bc-tool="release-scorecard"]').forEach(initReadinessScorecard);
})();
